import React, {useEffect, Suspense } from 'react';
import NgWrapper  from "./modules/app/NgWrapper";
import Intercom from "./modules/app/components/Intercom";
import { Route, Switch, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "./modules/app/components/MainHeader";
import PortalWidget from "./modules/app/components/PortalWidget"
import { MainLoader, removeMainLoader, DialogLazy } from "ui-components-rollup/dist/Loaders";
import {Notification} from "ui-components-rollup/dist/Widgets";
import NoAccountDialog from "./modules/app/components/NoAccountDialog"
import InactiveConnectorDialog from "./modules/app/components/InactiveConnectorDialog"
import Modal, {Content, Header, Footer} from "ui-components-rollup/dist/Modal";
import classNames from "classnames";
import buttons from "ui-components-rollup/src/components/buttons.module.scss";
import MoveToSaas from './modules/app/components/moveToSaas/MoveToSaas';
import SlidingManagementWidget from './modules/app/components/SlidingManagementWidget';
import DefaultRoute from "./modules/app/components/DefaultRoute";
import {Forbidden} from "./modules/app/components/NoAccessComponents";
import {lazy} from "react-imported-component";
import ServiceIntegration from "./modules/app/ServiceIntegration";
import AppNotifications from "modules/app/components/AppNotifications";
import { MonitorCurrentConnector } from "modules/current-connector";
import { history } from "store";

const Playground = lazy(() => import('./modules/playground'/* webpackChunkName: "Playground" */));

const GalleryTab = lazy(() => import('./modules/gallery'/* webpackChunkName: "Gallery" */).then(r => r.GalleryTab));
export const ProxyDialog = process.env.REACT_APP_IS_DARK !== "true" ?
	lazy(() => import("./modules/local" /* webpackChunkName: "Local" */).then(r => r.ProxyDialog)) :
	lazy(() => import("./modules/dark" /* webpackChunkName: "Dark" */).then(r => r.ProxyDialog));

export const SetupDialog = process.env.REACT_APP_IS_DARK !== "true" ?
	lazy(() => import("./modules/local" /* webpackChunkName: "Local" */).then(r => r.SetupDialog)) :
	lazy(() => import("./modules/dark" /* webpackChunkName: "Dark" */).then(r => r.SetupDialog));

export const DarkLogin = process.env.REACT_APP_IS_DARK === 'true' ?
    lazy(() => import("./modules/dark" /* webpackChunkName: "Dark" */).then(r => r.Login)):'';

const SpotTab = lazy(() =>  import('./modules/spot' /* webpackChunkName: "spot"*/));

const CVS = lazy(() => import('./modules/cvs' /* webpackChunkName: "cvs"*/));

const NetappInternal = lazy(() =>  import('./modules/netapp-internal' /* webpackChunkName: "Internal"*/));

const Support  = lazy(() =>  import('./modules/support' /* webpackChunkName: "Support"*/));

const Licenses  = lazy(() =>  import('./modules/licenses' /* webpackChunkName: "Licenses"*/));

const StorageResources  = lazy(() =>  import('./modules/storage' /* webpackChunkName: "StorageResources"*/));

const CreateNssModal = lazy(() =>  import('./modules/support/components/account/AddNssModal' /* webpackChunkName: "CreateNssModal"*/));

const HttpsSetup = lazy(() => import('modules/connector-settings/index' /* webpackChunkName: "HTTPS"*/).then(r => r.HttpsSetup));

const Timeline  = lazy(() =>  import('./modules/timeline' /* webpackChunkName: "Timeline"*/));

const AddNewWorkingEnvironment  = lazy(() =>  import('./modules/add-new-working-environment' /* webpackChunkName: "AddNewWorkingEnvironment"*/));

const ReplicationTab  = lazy(() =>  import('./modules/replication' /* webpackChunkName: "Replication"*/).then(r => r.ReplicationTab));

const ReplicationSetupWizard  = lazy(() =>  import('./modules/replication/wizard' /* webpackChunkName: "ReplicationWizard"*/).then(r => r.ReplicationSetupWizard));

const Settings = lazy(() => import('modules/connector-settings/index' /* webpackChunkName: "Settings"*/).then(r => r.Settings));

const Credentials = lazy(() => import('modules/credentials' /* webpackChunkName: "Credentials"*/));

const routesAvailableWithoutAnActiveConnector = ["/working-environments", "/timeline", "/replication", "/sync", "/add-working-environment-wizard", "/cloud-volumes-service","/connector-settings/credentials"];

const TimeoutModal = () => {
    const dispatch = useDispatch();
    const renew = () => {
        dispatch({
            type: "AUTH:RENEW-SSO"
        })
    };

    return <Modal closeTrigger={renew}>
        <Header>
            Authentication Renew
        </Header>
        <Content>
            Your login session as expired. Make sure you have internet connectivity.
        </Content>
        <Footer>
            <button className={classNames(buttons.primary)} onClick={renew}>Refresh.</button>
        </Footer>
    </Modal>;
};

const MainApp = () => {
    const dispatch = useDispatch();
    const isLoadingServices = useSelector(state => state.app.isLoadingServices);
    const isNssModalOpen = useSelector(state => state.support?.isNssModalOpen)
    const serviceIntegrationPaths = useSelector(state => state.app.serviceIntegrationPaths);
    const {isAuthenticated, userId, renewTimeout, status} = useSelector(state => state.auth);
    const { accountStatus, selectedAccountId, workspaceStatus, agentStatus, selectedAgentId, forbidden, isChangedAgent, isTransitionFromUnselectedToSelected, permissions, selectedAccount } = useSelector(state => state.tenancy);
    const dontShowMoveToSaasScreen = window.localStorage.getItem('occm.dont.show.move.to.saas.overlay') === "true";
    const noActiveAgentInSaasMode = process.env.REACT_APP_IS_SAAS === "true"  && agentStatus === "SUCCESS" && !selectedAgentId;
    useEffect(() => {
        if (isAuthenticated) {
            dispatch({
                type: "TENANCY:LOAD-ACCOUNTS"
            });
        }
    }, [isAuthenticated, userId, dispatch]);

    useEffect(() => {
        if(!isLoadingServices && isAuthenticated && accountStatus !== "PENDING") {
            dispatch({
                type: "APP:INITIALIZE-FEATURES"
            })
        }
    }, [isLoadingServices, isAuthenticated, dispatch, accountStatus]);

    if (isLoadingServices || !isAuthenticated) {
        if (status === 'PENDING') {
            return <MainLoader/>;
        } else if (status === 'UNSET') {
            return ""
        }
    }

    const showTabs = accountStatus === "SUCCESS" && workspaceStatus === "SUCCESS" && agentStatus !== "PENDING" && selectedAccountId;
    const showLoader = accountStatus === "PENDING" || (workspaceStatus === "PENDING" && selectedAccountId) || (agentStatus === "PENDING" && selectedAccountId);

    return <>
        <MainHeader/>

        {accountStatus === "SUCCESS" && !selectedAccountId && !forbidden && <div>
            <NoAccountDialog/>
        </div> }
        {isChangedAgent && <InactiveConnectorDialog/>}
        {process.env.REACT_APP_IS_SAAS !== "true" && !dontShowMoveToSaasScreen && process.env.REACT_APP_IS_DARK !== 'true' && selectedAccount?.isSaas && <MoveToSaas/>}
        {renewTimeout && <TimeoutModal/>}
        <SlidingManagementWidget/>
        <MonitorCurrentConnector/>
        {forbidden && <Forbidden/>}

        { isTransitionFromUnselectedToSelected && <Notification type="info" style={{width: 820, position: "fixed", bottom: 63, left: "50%", transform: "translateX(-50%)"}}>
            A Connector is now active—you can use all of the features and services within Cloud Manager.
        </Notification> }

        <Suspense fallback={<MainLoader/>}>
            <Switch>
                <Route path="/playground"><Playground/></Route>
                <Route path="/netapp-internal" render={() => <NetappInternal/>} />
                <Route>
                    <>
                        {showLoader && <MainLoader/>}
                        {isNssModalOpen && <CreateNssModal/>}
                        {showTabs && <Switch>
                            <Route path={serviceIntegrationPaths} render={() => <ServiceIntegration/>}/>
                            <Route path="/support-dashboard" render={() => <Support/>}/>
                            <Route path="/add-working-environment" render={() => <AddNewWorkingEnvironment/>}/>}
                            <Route path="/add-working-environment-wizard" render={() => <Redirect to={{pathname: "/add-working-environment/choose-type", hash: window.location.hash, state: history.location.state}}/>}/>}
                            {selectedAgentId && <Route path="/connector-settings/certificate-setup" render={() => <HttpsSetup/>}/>}
                            {selectedAgentId && <Route path="/connector-settings/settings" render={() => <Settings/>}/>}
                            {selectedAgentId && <Route path="/connector-settings/credentials" render={() => <Credentials/>}/>}
                            <Route path="/storage/:serviceKey" render={() => <DefaultRoute><StorageResources/></DefaultRoute>}/>
                            <Route path="/cvs" render={() => <CVS/>}/>
                            <Route path="/timeline" render={() => <DefaultRoute><Timeline/></DefaultRoute>}/>
                            <Route path="/compute" render={() => <DefaultRoute><SpotTab/></DefaultRoute>}/>
                            <Route path="/working-environments"><DefaultRoute><GalleryTab/></DefaultRoute></Route>
                            <Route path="/replication/setup"><DefaultRoute><ReplicationSetupWizard/></DefaultRoute></Route>
                            <Route path="/replication"><DefaultRoute><ReplicationTab/></DefaultRoute></Route>
                            <Route path="/licenses" render={() => <DefaultRoute><Licenses/></DefaultRoute>}/>
                            <Route path={routesAvailableWithoutAnActiveConnector} render={() => <DefaultRoute/>} />
                            {noActiveAgentInSaasMode && permissions.allTabsAvailable && <Route path="/:path" render={() => <Redirect to={{...history.location, hash: "#addConnector"}}/>}/>}
                            <Route path="/:path" render={() => <DefaultRoute />}/>
                            <Redirect to={{pathname: "/working-environments", hash: window.location.hash}}/>
                        </Switch>}
                    </>
                </Route>
            </Switch>
        </Suspense>
    </>
};

const App = React.memo(() => {
    const appState = useSelector(state => state.app.appState);
    removeMainLoader();
    return (
        <>
            {appState === 'loading' && <MainLoader/>}
            {appState === 'proxy' && <DialogLazy><ProxyDialog/></DialogLazy>}
            {appState === "setup-wizard" && <DialogLazy><SetupDialog/></DialogLazy>}
            {process.env.REACT_APP_IS_DARK === 'true' && <DialogLazy><DarkLogin/></DialogLazy>}
            <NgWrapper/>
            <Intercom/>
            <PortalWidget/>
            <AppNotifications/>
            {appState === 'ready' && <MainApp/>}
        </>
    );
});

export default App;
